import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-view-lp",
  templateUrl: "./med-icon-view-lp.component.html",
})
export class MedIconViewLpComponent extends SvgMixinComponent {}
